const accItem = document.getElementsByClassName('wp-block-deepsea-accordionitem');
const accHD = document.getElementsByClassName('accordion-title');

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

docReady(() => {
  function toggleItem() {
    const itemClass = this.parentNode.className;
    for (let i = 0; i < accItem.length; i += 1) {
      accItem[i].className = 'wp-block-deepsea-accordionitem close';
    }
    if (itemClass === 'wp-block-deepsea-accordionitem close') {
      this.parentNode.className = 'wp-block-deepsea-accordionitem open';
    }
  }

  for (let i = 0; i < accHD.length; i += 1) {
    accHD[i].addEventListener('click', toggleItem, false);
  }
});
